export default __webpack_public_path__ + "static/media/OpenSans-Bold.d687b4c4.woff";